import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  invite_data: {}
};

export default function action_store (state = initialState, action) {
  const { response } = action;
  switch (action.type) {
  case types.ACTION_STORE_FETCH_SUCCESS:
    return _.merge({}, state, {
      invite_data: response.invite_data
    });
  default:
    return state;
  }
}
